import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Testimonial from './components/Testimonial';
import WhatWeDo from './components/WhatWeDo';
import Team from './components/Team';
import Newsletter from './components/Newsletter';
import Notice from './components/Notice';
import Footer from './components/Footer';
import './App.css';

function App() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="app-container">
      <Header />
      <Hero />
      <Services />
      <Testimonial />
      <WhatWeDo />
      <Team />
      <Newsletter />
      <Notice />
      <Footer />
    </div>
  );
}

export default App;